import React, { createContext, useContext, useCallback, useMemo } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const SweetAlertContext = createContext();

export const useSweetAlert = () => {
  return useContext(SweetAlertContext);
};

export const SweetAlertProvider = ({ children }) => {
  const MySwal = useMemo(() => withReactContent(Swal), []);

  const showAlert = useCallback((config) => {
    return MySwal.fire(config);
  }, [MySwal]);

  const askYesNoQuestion = useCallback(async (title, message, useHtml = false) => {
    const result = await MySwal.fire({
      title,
      ...(useHtml ? { html: message } : { text: message }),
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      icon: 'question',
    });

    return result.isConfirmed;
  }, [MySwal]);

  const askCustomQuestion = useCallback(async (config) => {
    const result = await MySwal.fire({
      showCancelButton: true,
      ...config
    });
    return result;
  }, [MySwal]);


  const value = useMemo(() => ({ showAlert, askYesNoQuestion, askCustomQuestion }), [showAlert, askYesNoQuestion, askCustomQuestion]);

  return (
    <SweetAlertContext.Provider value={value}>
      {children}
    </SweetAlertContext.Provider>
  );
};
